var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocial5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9052 4.815C16.812 4.46231 16.6279 4.14024 16.3712 3.88097C16.1146 3.6217 15.7944 3.43431 15.4427 3.3375C14.1602 3 9.00022 3 9.00022 3C9.00022 3 3.84022 3 2.55772 3.3375C2.20599 3.43431 1.88582 3.6217 1.62918 3.88097C1.37255 4.14024 1.18843 4.46231 1.09522 4.815C0.84597 6.19567 0.730436 7.59715 0.750216 9C0.730436 10.4028 0.84597 11.8043 1.09522 13.185C1.18843 13.5377 1.37255 13.8598 1.62918 14.119C1.88582 14.3783 2.20599 14.5657 2.55772 14.6625C3.84022 15 9.00022 15 9.00022 15C9.00022 15 14.1602 15 15.4427 14.6625C15.7944 14.5657 16.1146 14.3783 16.3712 14.119C16.6279 13.8598 16.812 13.5377 16.9052 13.185C17.1545 11.8043 17.27 10.4028 17.2502 9C17.27 7.59715 17.1545 6.19567 16.9052 4.815Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 11.265L11.625 8.99999L7.3125 6.73499V11.265Z",
    fill: "#5B5FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial5);
export default __webpack_public_path__ + "static/media/social-5.5e33078523d741d8fa29448b5970ad4a.svg";
export { ForwardRef as ReactComponent };